/* Voujon — scroll-linked home hero zoom and upward section reveals.
   Only runs when the home page contains the hero section. */
(function () {
  'use strict';
  var main = document.getElementById('main');
  var hero = main && main.querySelector('.hero');
  if (!hero) return;

  var reduced = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var heroShell = hero.closest('.shopify-section');
  var shellIsDirect = heroShell && heroShell.parentElement === main;
  var shells = shellIsDirect ? Array.prototype.slice.call(main.children).filter(function (element) {
    return element.classList && element.classList.contains('shopify-section');
  }) : [];
  var sections = shells.filter(function (element) { return element !== heroShell; });

  main.classList.add('vs-home-motion');
  if (shellIsDirect && sections.length) {
    heroShell.classList.add('vs-home-hero-shell');
    sections.forEach(function (element) { element.classList.add('vs-home-section'); });
  }

  /* Follow vertical scrolling at most once per animation frame. */
  if (!reduced) {
    var frame = 0;
    function applyZoom() {
      frame = 0;
      var distance = Math.max(hero.offsetHeight || window.innerHeight, 1);
      var progress = Math.max(0, Math.min(1, window.scrollY / distance));
      hero.style.setProperty('--vs-hero-zoom', (1.03 + progress * 0.075).toFixed(4));
      var mobile = window.matchMedia('(max-width: 700px)').matches;
      hero.style.setProperty('--vs-hero-shift', (-progress * (mobile ? 28 : 12)).toFixed(1) + 'px');
    }
    function queueZoom() {
      if (!frame) frame = window.requestAnimationFrame(applyZoom);
    }
    applyZoom();
    window.addEventListener('scroll', queueZoom, { passive: true });
    window.addEventListener('resize', queueZoom, { passive: true });
  }

  /* Reveal each section as it comes into view rather than forcing hidden
     content on browsers where IntersectionObserver is unavailable. */
  if (!reduced && sections.length && 'IntersectionObserver' in window) {
    sections.forEach(function (element) {
      var bounds = element.getBoundingClientRect();
      if (bounds.top < window.innerHeight * .94 && bounds.bottom > 0) {
        element.classList.add('vs-home-section-visible');
      }
    });
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('vs-home-section-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -5% 0px' });
    sections.forEach(function (element) {
      if (!element.classList.contains('vs-home-section-visible')) observer.observe(element);
    });
    main.classList.add('vs-home-animate');
  } else {
    sections.forEach(function (element) {
      element.classList.add('vs-home-section-visible');
    });
  }
})();
